export default __webpack_public_path__ + "static/8_21-06402b8ca0ed9a863da525eecb4368a3.png";